var map = {
	"./colis/colis_2.jpg": 168,
	"./foret/foret_2.jpg": 5628,
	"./genie/genie_2.jpg": 5826,
	"./porte/porte_2.jpg": 478,
	"./vaisseau/vaisseau_2.jpg": 4661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4051;